/**
 * Transaction Input Validator
 * Validates transaction data before sending to Firestore
 */

export function validateTransactionInput(raw) {
  const errors = [];

  // type
  if (raw.type !== 'expense' && raw.type !== 'income') {
    errors.push('Type must be "expense" or "income".');
  }

  // amount
  const amount = Number(raw.amount);
  if (!Number.isFinite(amount) || amount <= 0) {
    errors.push('Amount must be a positive number.');
  }

  // description
  const description = (raw.description || '').trim();
  if (!description) {
    errors.push('Description is required.');
  }

  return {
    isValid: errors.length === 0,
    errors,
    parsed: {
      ...raw,
      amount,
      description,
    },
  };
}
